import * as Sentry from '@sentry/react';
import { getConfig } from 'config';

if (getConfig().ENVIRONMENT !== 'local') {
    Sentry.init({
        dsn: 'https://a12fa64269a804e6bd7aa70f63e62aff@o4508497307893760.ingest.us.sentry.io/4508521381691393',
        integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
        environment: getConfig().ENVIRONMENT,
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost']
    });
}
